import { render } from "./VideoJS.vue?vue&type=template&id=337d2a5e"
import script from "./VideoJS.vue?vue&type=script&lang=js"
export * from "./VideoJS.vue?vue&type=script&lang=js"

import "./VideoJS.vue?vue&type=style&index=0&id=337d2a5e&lang=css"

import exportComponent from "/home/runner/work/dl-viewer/dl-viewer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__